import React from "react";
import { FaCheck } from "react-icons/fa";
import { RxCross1 } from "react-icons/rx";

const ProductOffering = () => {
  const card1Text = [
    { text: "Core Platform", icon: <FaCheck /> },
    { text: "Simulations & Scenario Analysis", icon: <FaCheck /> },
    { text: "Workflow & Collaboration Tools", icon: <FaCheck /> },
    { text: "Curated Market Data", icon: <FaCheck /> },
    { text: "Standard Reports & Dashboards", icon: <FaCheck /> },
    { text: "Specific Package", icon: <FaCheck /> },
    { text: "Custom AI Agents", icon: <RxCross1 /> },
    { text: "Custom Workflows & Optimizers", icon: <RxCross1 /> },
    { text: "Industry-specific Data & Analysis", icon: <RxCross1 /> },
    { text: "Real time Market Intelligence", icon: <RxCross1 /> },
  ];

  const card2Text = [
    { text: "Core Platform", icon: <FaCheck /> },
    { text: "Simulations & Scenario Analysis", icon: <FaCheck /> },
    { text: "Workflow & Collaboration Tools", icon: <FaCheck /> },
    { text: "Curated Market Data", icon: <FaCheck /> },
    { text: "Standard Reports & Dashboards", icon: <FaCheck /> },
    { text: "Specific Package", icon: <FaCheck /> },
    { text: "Custom AI Agents", icon: <FaCheck /> },
    { text: "Custom Workflows & Optimizers", icon: <FaCheck /> },
    { text: "Industry-specific Data & Analysis", icon: <FaCheck /> },
    { text: "Real time Market Intelligence", icon: <FaCheck /> },
  ];

  const card3Text = [
    { text: "Dsider Premium Product / Flexible Consumption", icon: <FaCheck /> },
    { text: "Network-wide Analysis", icon: <FaCheck /> },
    { text: "Advanced Decision Intelligence", icon: <FaCheck /> },
    { text: "Automated Multi-Objective Optimization", icon: <FaCheck /> },
    { text: "Comprehensive Analytics Suite", icon: <FaCheck /> },
    { text: "AI Assisted Services", icon: <FaCheck /> },
  ];

  return (
    <div className="product-offering">
      <h1 className="packages-container" style={{ marginTop: '5rem' }}>Offering</h1>
      <div className="cards-container">
        <div className="card card-1">
          <h2 className="card-heading">
            Dsider <br />{" "}
            <span style={{ color: "rgba(53, 148, 107, 1)" }}>Foundation</span>
          </h2>
          <div className="features">
            {card1Text.map((item, index) => (
              <div
                key={index}
                className="feature-item"
                style={{
                  opacity: item.icon.type === RxCross1 ? "30%" : "100%",
                }}
              >
                {item.icon}
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="card card-2">
          <h2 className="card-heading">
            <span style={{ color: "#fff" }}>Dsider</span> <br />{" "}
            <span style={{ color: "rgba(255, 197, 80, 1)" }}>Premium</span>
          </h2>
          <div className="features">
            {card2Text.map((item, index) => (
              <div
                key={index}
                className="feature-item"
                style={{ color: "#fff" }}
              >
                {item.icon}
                <span style={{ color: "#fff" }}>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="card card-3">
          <h2 className="card-heading">
            <span>Dsider</span> <br /> As a Service
          </h2>
          <div className="features">
            {card3Text.map((item, index) => (
              <div
                key={index}
                className="feature-item"
                style={{ color: "#fff" }}
              >
                {item.icon}
                <span style={{ color: "#fff" }}>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductOffering;
